import React from 'react';

import { TermsPage } from '@zg-rentals/screening-js';
import StyledContainer from '@zg-rentals/multibrand-ui/lib/StyledContainer';

import './TermsPage.scss';

export default function ApplicationsLandlordTermsPage() {
  return (
    <StyledContainer backgroundColor="zrmBackground" className="App__wrapper">
      <TermsPage className="TermsPage__wrapper" />
    </StyledContainer>
  );
}
